import generateUtilityClass from '../../utils/esm/generateUtilityClass/generateUtilityClass.esm.js';
import generateUtilityClasses from '../../utils/esm/generateUtilityClasses/generateUtilityClasses.esm.js';

function getCollapseUtilityClass(slot) {
  return generateUtilityClass('MuiCollapse', slot);
}
generateUtilityClasses('MuiCollapse', ['root', 'horizontal', 'vertical', 'entered', 'hidden', 'wrapper', 'wrapperInner']);

export { getCollapseUtilityClass };
